export default __webpack_public_path__ + "52622e297a567dca9ef33ad01395b6bf.png";